module.exports = __webpack_public_path__ + "static/continuous-model-improvement-7fc6844155649b1c4fb4d2eadb1edff3.svg";